export default __webpack_public_path__ + "static/media/pacakgeModal1.df50c9ff.png";